import React from 'react'
import { Navigate, useNavigate } from 'react-router-dom'

const useNavigation = () => {
 const navigate=useNavigate();

 const Goback=()=>{
    navigate(-1);
 }
 const Goto=(url,options={})=>{
   navigate(url,options);
 }

const Gobanner=(url, data = {}, options = {})=>{
navigate(url, {
  ...options,
  state: {
    ...(options.state || {}),
    ...data
  }
});
}

 return({
    Goback,
    Goto,
    Gobanner
 })
}

export default useNavigation
